import { MIN_PART_NUMBER_LEN } from '../../../components/bearing-search/api/api';
import { TimkenUnitDimension } from '../../../components/bearing-search/types/types';
import { handleActionError } from '../../utils/engineering-tools';

export type PartNumberSearchState = {
	partNumber: string;
	unitDimension: TimkenUnitDimension;
	requestData?: {
		partNumber: string
	};
	isPartNumberValid: boolean;
	isValidated: boolean;
};

export const initialSealPartState: PartNumberSearchState = {
	partNumber: '',
	unitDimension: 'Metric',
	isPartNumberValid: false,
	isValidated: false,
};

export type PartNumberSearchAction =
	| { type: 'change_part_number'; payload: string }
	| { type: 'change_unit'; payload: TimkenUnitDimension }
	| { type: 'change_validation_flag'; payload: boolean }
	| { type: 'update_request_data' }
	| { type: 'reset'; payload?: PartNumberSearchState };

const sealPartReducer: React.Reducer<
	PartNumberSearchState,
	PartNumberSearchAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_part_number': {
			const partNumber = action.payload;
			const isPartNumberValid = partNumber.trim().length >= MIN_PART_NUMBER_LEN;

			return {
				...state,
				partNumber,
				isPartNumberValid,
			};
		}
		case 'change_unit': {
			return {
				...state,
				unitDimension: action.payload,
			};
		}
		case 'change_validation_flag': {
			return {
				...state,
				isValidated: action.payload,
			};
		}
		case 'update_request_data': {
			const requestData = state.isPartNumberValid ? { partNumber: state.partNumber } : undefined;

			return {
				...state,
				requestData,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialSealPartState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default sealPartReducer;
